// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup-module-popup","isVisible":"Popup-module-is-visible","headline":"Popup-module-headline","description":"Popup-module-description"};